import { Typography as FoodsTypography } from "@foodpilot/foods";
import { t } from "i18next";
import { forwardRef } from "react";

export type TypographyProps = {
    variant?:
        | "h1"
        | "h2"
        | "h3"
        | "h4"
        | "h5"
        | "h6"
        | "subtitle1"
        | "subtitle2"
        | "body1"
        | "body2"
        | "caption"
        | "overline";
    align?: "left" | "center" | "right" | "justify";
    color?: string;
    content: string;
    gutterBottom?: boolean;
    noWrap?: boolean;
};

type PuckProps = {
    puck?: Record<string, unknown>;
    id?: string;
};

type CombinedProps = TypographyProps & PuckProps;

export const Typography = forwardRef<HTMLDivElement, CombinedProps>((props, ref) => {
    const { content, variant, align, color } = props;

    const isTranslationKey =
        typeof content === "string" && content.trim() !== "" && !content.includes(" ") && !content.includes("\n");

    const displayContent = isTranslationKey ? t(content, content) : content;

    return (
        <FoodsTypography ref={ref} variant={variant} align={align} color={color}>
            {displayContent}
        </FoodsTypography>
    );
});

Typography.displayName = "Typography";
